import { injectable } from 'tsyringe';
import { DataKepesantrenanRepositoryInterface } from '../../../data/contracts/DataKepesantrenan';
import { DataKepesantrenan } from '../../../entities/DataKepesantrenan';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';

@injectable()
export class DataKepesantrenanApiRepository
  implements DataKepesantrenanRepositoryInterface
{
  private apiService: ApiService;
  private endpoints: Endpoints;

  constructor(apiService: ApiService, endpoints: Endpoints) {
    this.apiService = apiService;
    this.endpoints = endpoints;
  }

  public async getMyData(): Promise<DataKepesantrenan | null> {
    const headers = new Map<string, string>();
    const response = await this.apiService.invoke(
      'get',
      this.endpoints.dataKepesantrenan(),
      {},
      null,
      headers
    );

    const d = response?.data?.data;
    if (!d) return null;

    return new DataKepesantrenan(
      d.id ?? null,
      d.user_id,
      d.nama_pesantren,
      d.nsp,
      d.alamat,
      d.provinsi_id,
      d.kabupaten_id,
      d.kecamatan_id,
      d.peran,
      d.tahun_bergabung,
      d.status_mukim ?? null,
    );
  }

  public async simpan(
    pelatihanId: number,
    isPesantren: number,
    namaPesantren: string | null,
    nsp: string | null,
    alamat: string | null,
    provinsiId: number | null,
    kabupatenId: number | null,
    kecamatanId: number | null,
    peran: string | null,
    tahunBergabung: number | null,
    statusMukim: number | null,
  ): Promise<any> {
    const headers = new Map<string, string>();
    const formData = new FormData();
    formData.append('pelatihan_id', String(pelatihanId));
    formData.append('is_pesantren', String(isPesantren));

    if (isPesantren === 1) {
      if (namaPesantren !== null) formData.append('nama_pesantren', namaPesantren);
      if (nsp !== null) formData.append('nsp', nsp);
      if (alamat !== null) formData.append('alamat', alamat);
      if (provinsiId !== null) formData.append('provinsi_id', String(provinsiId));
      if (kabupatenId !== null) formData.append('kabupaten_id', String(kabupatenId));
      if (kecamatanId !== null) formData.append('kecamatan_id', String(kecamatanId));
      if (peran !== null) formData.append('peran', peran);
      if (tahunBergabung !== null) formData.append('tahun_bergabung', String(tahunBergabung));
      if (statusMukim !== null) formData.append('status_mukim', String(statusMukim));
    }

    return this.apiService.invoke(
      'post',
      this.endpoints.dataKepesantrenanSimpan(),
      {},
      formData,
      headers
    );
  }

  public async simpanMaster(
    isPesantren: number,
    namaPesantren: string | null,
    nsp: string | null,
    alamat: string | null,
    provinsiId: number | null,
    kabupatenId: number | null,
    kecamatanId: number | null,
    peran: string | null,
    tahunBergabung: number | null,
    statusMukim: number | null,
  ): Promise<any> {
    const headers = new Map<string, string>();
    const formData = new FormData();
    formData.append('is_pesantren', String(isPesantren));

    if (isPesantren === 1) {
      if (namaPesantren !== null) formData.append('nama_pesantren', namaPesantren);
      if (nsp !== null) formData.append('nsp', nsp);
      if (alamat !== null) formData.append('alamat', alamat);
      if (provinsiId !== null) formData.append('provinsi_id', String(provinsiId));
      if (kabupatenId !== null) formData.append('kabupaten_id', String(kabupatenId));
      if (kecamatanId !== null) formData.append('kecamatan_id', String(kecamatanId));
      if (peran !== null) formData.append('peran', peran);
      if (tahunBergabung !== null) formData.append('tahun_bergabung', String(tahunBergabung));
      if (statusMukim !== null) formData.append('status_mukim', String(statusMukim));
    }

    return this.apiService.invoke(
      'post',
      this.endpoints.dataKepesantrenanSimpanMaster(),
      {},
      formData,
      headers
    );
  }
}
